import Vue from 'vue'
import { format, fromUnixTime, startOfDay, getUnixTime, parseISO, isBefore } from 'date-fns'
import { filterRacesByCountry, filterRacesByCodes, filterRacesByMeetingType, filterRacesByStatuses, filterRacesByStarters, filterRacesByDistance, filterRacesByCondition, countdown, filterMeetingsByCountry, filterMeetingsByCodes } from '../common/methods'
import { zonedTimeToUtc } from 'date-fns-tz'
import axios from 'axios'
import { bookies, meetingsDated, meetingJockeys, subscribeRaceUpdates, queryRace, subscribeDetailedRace, sportTypes, sportCategories, sportMarkets } from '../common/queries'
import { apolloClient } from '../vue-apollo'
import gql from 'graphql-tag'
import { mapMeetings, mapRace } from '../utils/mapGraphql'
import { setUserFilter, batchFetch } from '../services/userConfig'
import { defaultCountries, defaultCodes } from './userConfig'
import socket from './socket'

const terminalAxios = axios.create({
  baseURL: process.env.VUE_APP_ENDPOINT_API_TERMINAL
});

terminalAxios.interceptors.request.use(function (config) {
  const token = window.localStorage.getItem('auth_token')
  config.headers.Authorization =  token;

   return config;
});

const store = {
  state: {
    filterRacesByFinalStatus: false,
    loggedIn: false,
    meetingsDated: {},
    selectedDate: startOfDay(Date.now()),
    selectedDateMeetingSummary: startOfDay(Date.now()),
    selectedRace: {
      id: null,
      MeetingID: null,
      RaceNumber: null
    },
    selectedNavRace: {
      id: null,
      MeetingID: null,
      RaceNumber: null
    },
    meetings: {},
    races: {},
    meetingSummaryMeetings: {},
    meetingSummaryRaces: {},
    raceCompetitors: [],
    jockeyNames: [],
    audits: [],
    bookies: [],
    sportTypes: [],
    styles: [],
    renderingErrors: [],
    detailedRaces: {},
    detailedRaceSubscription: null,
    racesGroupedByMeeting: [],
    silksErrorsLoading: false,
    users: [],
    user: {},
    sportMarkets: [],
    sportCategories: {},
    sportResultSelections: [],
    sportEvent: {},
    priceSources: [],
    shapes: [],
    roles: [],
    usersWithRoles: [],
    userLoggedIn: {},
    racesSilksDialog: true
  },
  mutations: {
    SOCKET_ONOPEN (state, event) {
      Vue.prototype.$socket = event.currentTarget
      socket.authenticate(
        state.account.user
          .getSignInUserSession()
          .getAccessToken()
          .getJwtToken()
      )
      socket.subscribeStyleCreated()
      socket.subscribeIncomingOctTerminal()
    },
    SOCKET_RECONNECT () {

    },
    SOCKET_RECONNECT_ERROR () {

    },
    SOCKET_ONMESSAGE (/* state, msg */) {
      //
    },
    SOCKET_ONERROR () {

    },
    SOCKET_ONCLOSE () {

    },
    addApolloClient () {
      //
    },
    authState (state, isLogged) {
      state.loggedIn = isLogged
    },
    clearAudits (state) {
      state.audits = []
    },
    clearBookies (state) {
      state.bookies = []
    },
    clearSportTypes (state) {
      state.sportTypes = []
    },
    clearRaces (state) {
      if (state.selectedRace.id !== null) {
        const detRace = state.detailedRaces[state.selectedRace.id]
        const keepMeetings = Object.values(state.meetings).filter(meeting => meeting.id === detRace.meeting.id)
        const keepRaces = Object.values(state.races).filter(race => race.meeting.id === detRace.meeting.id)
        const racesObject = {}
        keepRaces.forEach((race) => {
          racesObject[race.id] = race
        })
        const meetingObject = {}
        keepMeetings.forEach((meeting) => {
          meetingObject[meeting.id] = meeting
        })

        state.meetings = meetingObject
        state.races = racesObject
      } else {
        state.meetings = {}
        state.races = {}
      }
    },
    clearMeetingSummaryRaces (state) {
      state.meetingSummaryRaces = {}
    },
    clearStyles (state) {
      state.styles = []
    },
    clearRenderingErrors (state) {
      state.renderingErrors = []
    },
    clearRaceCompetitors (state) {
      state.raceCompetitors = []
    },
    filterRacesByFinalStatus (state, filterRacesByFinalStatus) {
      state.filterRacesByFinalStatus = filterRacesByFinalStatus
    },
    /* selectRace (state, { name, raceId, externalMeetingID, raceNumber, country, venue, meetingType, meetingID, startTime, raceStatus }) {
      state.selectedRace.name = name
      state.selectedRace.raceId = raceId
      state.selectedRace.externalMeetingID = externalMeetingID
      state.selectedRace.raceNumber = raceNumber
      state.selectedRace.country = country
      state.selectedRace.venue = venue
      state.selectedRace.meetingType = meetingType
      state.selectedRace.meetingID = meetingID
      state.selectedRace.startTime = startTime
      state.selectedRace.raceStatus = raceStatus
    }, */
    selectRace (state, { id }) {
      state.selectedRace = {}
      state.selectedRace.id = id
    },
    setDate (state, d) {
      const date = zonedTimeToUtc(d, 'GMT')
      state.selectedDate = date
    },
    setDateMeetingSummary (state, d) {
      const date = zonedTimeToUtc(d, 'GMT')
      state.selectedDateMeetingSummary = date
    },
    updateAudits (state, { audits }) {
      state.audits = audits
    },
    updateBookies (state, { bookies }) {
      state.bookies = bookies
    },
    updateSportTypes (state, { sportTypes }) {
      state.sportTypes = sportTypes
    },
    updateSportCategories (state, { sportCategories, sportTypeId }) {
      Vue.set(state.sportCategories, sportTypeId, sportCategories)
    },
    clearSportResultSelections (state) {
      state.sportResultSelections = []
    },
    updateSportResultSelections (state, { sportResultSelections }) {
      state.sportResultSelections = sportResultSelections
    },
    updateRace (state, { raceUpdate }) {
      const key = `${raceUpdate.id}`
      const race = state.races[key]
      if (race) {
        if (raceUpdate.competitors && raceUpdate.competitors.length > 0) {
          const competitors = [...race.competitors]
          raceUpdate.competitors.forEach(competitor => {
            const index = competitors.findIndex(c => c.tabNo === competitor.tabNo)
            if (index) {
              competitors[index] = competitor
            }
          })
          const newDetailedRace = { ...raceUpdate, competitors }
          Vue.set(state.races, key, newDetailedRace)
        } else {
          Vue.set(state.races, key, raceUpdate)
        }
      }
    },
    updateRenderingErrors (state, { renderingErrors }) {
      state.renderingErrors = renderingErrors
    },
    updateStyles (state, { styles }) {
      state.styles = styles
    },
    updateRaceSummary (state, { race, meeting }) {
      /* Vue.set(state.meetings, meeting.ExternalMeetingID, meeting)
      const key = `${race.id}`
      Vue.set(state.races, key, race) */
      Vue.set(state.meetings, meeting.id, meeting)
      const key = `${race.id}`
      const newMeeting = {}
      newMeeting.id = meeting.id
      newMeeting.track = meeting.track
      newMeeting.type = meeting.type
      newMeeting.externalIDs = meeting.externalIDs
      newMeeting.tabIndicator = meeting.tabIndicator
      newMeeting.date = meeting.date
      const newRace = {
        ...race,
        isoStartTime: parseISO(race.startTime),
        meeting: newMeeting
      }

      Vue.set(state.races, key, newRace)
    },
    updateRaceMeetingSummary (state, { race, meeting }) {
      Vue.set(state.meetingSummaryMeetings, meeting.ExternalMeetingID, meeting)
      const key = `${race.id}`
      Vue.set(state.meetingSummaryRaces, key, race)
    },
    updateRaceCountdown (state) {
      const races = state.races
      Object.keys(races).forEach((b) => {
        const race = races[b]
        const time = getUnixTime(parseISO(race.startTime))
        const formattedStartTime = countdown(time)
        Vue.set(race, 'formattedStartTime', formattedStartTime)
      })
    },
    updateDetailedRace (state, { race }) {
      const key = `${race.id}`
      // Object.freeze(race)
      Vue.set(state.detailedRaces, key, race)
    },
    updateRaceDetail (state, { detailedRace }) {
      const key = `${detailedRace.id}`
      Vue.set(state.detailedRaces, key, detailedRace)
    },
    updateDetailedRaceSubscription (state, { subscription }) {
      if (state.detailedRaceSubscription) {
        state.detailedRaceSubscription.unsubscribe()
      }
      state.detailedRaceSubscription = subscription
    },
    setSelectRaceNav (state, m) {
      state.selectRaceNavSet = m
    },
    selectNavRace (state, { id }) {
      state.selectedNavRace.id = id
    },
    setRacesGroupedByMeeting (state, { meetingsGrouped }) {
      state.racesGroupedByMeeting = meetingsGrouped
    },
    clearRacesGroupedByMeeting (state) {
      state.racesGroupedByMeeting = []
    },
    updateSilksErrorsLoading (state, { value }) {
      state.silksErrorsLoading = value
    },
    saveUsers (state, { users }) {
      state.users = users
    },
    saveUser (state, { user }) {
      state.user = user
    },
    clearSportMarkets (state) {
      state.sportMarkets = []
    },
    updateSportMarkets (state, { markets }) {
      state.sportMarkets = markets
    },
    updateSportEventSelected (state, { sportEvent }) {
      state.sportEvent = sportEvent
    },
    clearPriceSources (state) {
      state.priceSources = []
    },
    updatePriceSources (state, { priceSources }) {
      state.priceSources = priceSources
    },
    clearShapes (state) {
      state.shapes = []
    },
    updateShapes (state, { shapes }) {
      state.shapes = shapes
    },
    saveRoles (state, { roles }) {
      state.roles = roles
    },
    saveUsersWithRoles (state, { users }) {
      state.usersWithRoles = users
    },
    saveUserLoggedIn (state, { user }) {
      state.userLoggedIn = user
    },
    setRacesSilksDialog (state, { value }) {
      state.racesSilksDialog = value
    }
  },
  actions: {
    updateClocks (context) {
      context.commit('updateRaceCountdown')
    },
    async abandonMeeting (context) {
      const race = context.state.races[context.state.selectedRace.id]
      const meetingID = race.meeting.id
      const races = context.state.meetings[meetingID].Races
      var arrayRaces = []

      races.forEach(r => {
        if (r.status === 'OPEN') {
          arrayRaces.push(r.Number)
        }
      })

      try {
        await axios.post('api.public.Public/AbandonRaces', {
          meetingID: race.meeting.externalIDs[0].id,
          races: arrayRaces,
          country: race.meeting.track.country,
          date: format(context.state.selectedDate, 'dd/MM/yyyy'),
          venue: race.meeting.track.name,
          meetingType: race.meeting.type
        }, {
          
        })
      } catch (error) {
        //
      }
    },
    async abandonRaces (context) {
      const race = context.state.races[context.state.selectedRace.id]
      try {
        await axios.post('api.public.Public/AbandonRaces', {
          meetingID: race.meeting.externalIDs[0].id,
          races: [
            race.number
          ],
          country: race.meeting.track.country,
          date: format(context.state.selectedDate, 'dd/MM/yyyy'),
          venue: race.meeting.track.name,
          meetingType: race.meeting.type
        }, {
          
        })
      } catch (error) {
        //
      }
    },
    addApolloClient (context, client) {
      context.commit('addApolloClient', client)
    },
    authState (context, isLogged) {
      context.commit('authState', isLogged)
    },
    async auditsByRaceNumber (context) {
      
      const race = context.state.races[context.state.selectedRace.id]
      try {
        const res = await axios.post('api.public.Public/GetAuditByRaceNumber', {
          raceNumber: race.number,
          GBSMeetingID: race.meeting.externalIDs[0].id
        }, {
          
        })
        context.commit('clearAudits')
        const audits = res.data.audits
        audits.forEach(a => {
          const formatted = format(fromUnixTime(a.created.seconds), 'MMM d, yyyy HH:mm')
          a.created = formatted
          const user = a.userID.split('_')[1]
          a.userID = user
          const action = a.action.split(':')
          if (action.length > 1) a.action = action[1]
          else a.action = action[0]
        })
        context.commit('updateAudits', { audits: audits })
      } catch (error) {
        //
      }
    },
    async createShape (context, { name, section, defs, twoColors }) {
      try {
        await axios.post('api.public.Public/CreateShape', {
          shape: {
            name: name,
            section: section,
            defs: defs,
            twoColors: twoColors
          }
        }, {
          
        })
      } catch (error) {
        //
      }
    },
    async fetchShapes (context) {
      try {
        const res = await axios.post('api.public.Public/GetShapes', {}, {
          
        })
        context.commit('clearShapes')
        const shapes = res.data.shapes
        context.commit('updateShapes', { shapes: shapes })
      } catch (error) {
        //
      }
    },
    async deleteShape (context, { id }) {
      try {
        await axios.post('api.public.Public/DeleteShape', {
          id: id
        }, {
          
        })
      } catch (error) {
        //
      }
    },
    async updateShape (context, { id, name, section, defs, twoColors }) {
      try {
        await axios.post('api.public.Public/UpdateShape', {
          shape: {
            id: id,
            name: name,
            section: section,
            defs: defs,
            twoColors: twoColors
          }
        }, {
          
        })
      } catch (error) {
        //
      }
    },
    async createStyle (context, { fragment, section, style, defs, renderWithBaseColor, shapeId }) {
      try {
        if (renderWithBaseColor) {
          defs = defs.replace(/id="([^"]+)"/g, 'id="{{.ID}}"')
          defs = defs.replace(/fill="([^"]+)"/, 'fill="{{.BaseColor}}"')
        }
        await axios.post('api.public.Public/CreateStyle', {
          style: {
            fragment: fragment,
            section: section,
            style: style,
            defs: defs,
            renderWithBaseColor: renderWithBaseColor,
            shapeId: shapeId
          }
        }, {
          
        })
        context.dispatch('regenerateRunnerSilksByFragment', { fragment: fragment })
      } catch (error) {
        //
      }
    },
    regenerateRunnerSilksByFragment (context, { fragment }) {
      axios.post('api.public.Public/RegenerateRunnerSilksByFragment', {
        Fragment: fragment
      }, {
        
      })
    },
    async deleteStyle (context, { fragment }) {
      try {
        await axios.post('api.public.Public/DeleteStyle', {
          fragment: fragment
        }, {
          
        })
      } catch (error) {
        //
      }
    },
    async fetchRenderingErrors (context) {
      try {
        const res = await axios.post('api.public.Public/GetRenderingErrors', {}, {
          
        })
        context.commit('clearRenderingErrors')
        const rederingErrorsRsp = res.data.records
        context.commit('updateRenderingErrors', { renderingErrors: rederingErrorsRsp })
      } catch (error) {
        //
      }
    },
    async fetchStyles (context) {
      try {
        const res = await axios.post('api.public.Public/GetStyles', {}, {
          
        })
        context.commit('clearStyles')
        const stylesRsp = res.data.styles
        stylesRsp.forEach(style => {
          style.preview = style.preview.replace(/id="([^"]+)"/g, 'id="' + style.fragment.replace(/ /g, '-') + '"')
        })
        context.commit('updateStyles', { styles: stylesRsp })
      } catch (error) {
        //
      }
    },
    async fetchBookies (context) {
      try {
        const query = bookies
        const result = await apolloClient.query({
          query: gql`${query}`
        })
        context.commit('clearBookies')
        const listBookies = result.data.sources
        context.commit('updateBookies', { bookies: listBookies })
      } catch (error) {
        //
      }
    },
    async fetchSportTypes (context) {
      try {
        const query = sportTypes
        const result = await apolloClient.query({
          query: gql`${query}`
        })
        context.commit('clearSportTypes')
        const listSportTypes = result.data.sportTypes
        context.commit('updateSportTypes', { sportTypes: listSportTypes })
      } catch (error) {
        //
      }
    },
    async fetchSportCategories (context, { sportTypeId }) {
      try {
        const query = sportCategories(sportTypeId)
        const result = await apolloClient.query({
          query: gql`${query}`
        })
        const listSportCategories = result.data.sportCategories
        // console.log(listSportCategories)
        context.commit('updateSportCategories', { sportCategories: listSportCategories, sportTypeId: sportTypeId })
        // return listSportCategories
      } catch (error) {
        //
      }
    },
    async fetchSportMarkets (context, { event }) {
      try {
        const query = sportMarkets(JSON.stringify(event.id))
        const result = await apolloClient.query({
          query: gql`${query}`
        })
        context.commit('clearSportMarkets')
        context.commit('clearSportResultSelections')
        const markets = result.data.sportMarkets
        // return markets
        context.commit('updateSportMarkets', { markets: markets })
        context.commit('updateSportEventSelected', { sportEvent: event })
      } catch (error) {
        //
      }
    },
    fetchSportResultSelections (context, { sportMarketName }) {
      const markets = context.getters.getSportMarkets
      const result = markets.filter(market => market.name === sportMarketName)
      context.commit('updateSportResultSelections', { sportResultSelections: result })
    },
    async fetchMeetingJockeys (context) {
      const race = context.state.races[context.state.selectedRace.id] || context.state.meetingSummaryRaces[context.state.selectedRace.id]
      const meetingID = JSON.stringify(race.meeting.id)
      try {
        const query = meetingJockeys(meetingID)
        const result = await apolloClient.query({
          query: gql`${query}`
        })
        const races = result.data.meeting.races
        var jockeysSorted = []
        races.forEach(race => {
          race.competitors.forEach(competitor => {
            if (competitor.jockey !== '') jockeysSorted.push(competitor.jockey)
            jockeysSorted = [...new Set(jockeysSorted)]
            jockeysSorted = jockeysSorted.sort()
            context.state.jockeyNames = jockeysSorted
          })
        })
      } catch (error) {
        //
      }
    },
    async fetchRaces (context) {
      const d = zonedTimeToUtc(startOfDay(context.state.selectedDate), 'GMT')
      try {
        const date = JSON.stringify(d)
        const query = meetingsDated(date)
        const result = await apolloClient.query({
          query: gql`${query}`
        })
        const meetings = mapMeetings(result.data.meetingsDated)
        meetings.sort((a, b) => a.track.name < b.track.name ? -1 : 1)

        context.commit('setRacesGroupedByMeeting', { meetingsGrouped: meetings })
        context.commit('clearRaces')
        meetings.forEach(m => {
          m.Races.forEach(r => {
            context.commit('updateRaceSummary', { race: r, meeting: m })
          })
        })
        const nextRace = context.getters.getNextToGo
        if (nextRace !== null && nextRace.id) {
          await context.dispatch('selectRace', { id: nextRace.id })
        } else {
          const races = context.state.races
          const keys = Object.keys(races)
          const firstRace = races[keys[0]]
          if (firstRace.id) context.dispatch('selectRace', { id: firstRace.id })
        }
        context.commit('updateRaceCountdown')
        context.dispatch('subscribeRaceUpdates', { date })

        context.commit('updateSilksErrorsLoading', { value: true })
        for (const meeting of meetings) {
          for (const race of meeting.Races) {
            if (meeting.meetingType !== 'GREYHOUND') {
              const GBSMeetingID = race.meeting.externalIDs[0].id
              const raceNumber = race.number

              const silksErrorIndicator = await context.dispatch('silksErrorsByRace', { GBSMeetingID: GBSMeetingID, raceNumber: raceNumber })

              if (silksErrorIndicator === 1) {
                race.silksErrorIndicator = 1
                if (!meeting.silksErrorIndicator) {
                  meeting.silksErrorIndicator = 1
                }
              }
            }
          }
        }
        context.commit('clearRacesGroupedByMeeting')
        context.commit('setRacesGroupedByMeeting', { meetingsGrouped: meetings })
        // context.commit('updateSilksErrorsLoading', { value: false })
        // context.commit('clearStyle')
      } catch (error) {
        //
      }
    },
    async fetchMeetingSummaryRaces (context) {
      const d = zonedTimeToUtc(startOfDay(context.state.selectedDateMeetingSummary), 'GMT')
      try {
        const date = JSON.stringify(d)
        const query = meetingsDated(date)
        const result = await apolloClient.query({
          query: gql`${query}`
        })
        const meetings = mapMeetings(result.data.meetingsDated)
        context.commit('clearMeetingSummaryRaces')
        meetings.forEach(m => {
          m.Races.forEach(r => {
            context.commit('updateRaceMeetingSummary', { race: r, meeting: m })
          })
        })
        context.dispatch('subscribeRaceUpdates', { date })
      } catch (error) {
        //
      }
    },
    filterRacesByFinalStatus (context, filterByFinalStatus) {
      context.commit('filterRacesByFinalStatus', filterByFinalStatus)
    },
    async subscribeRaceUpdates (context, { date }) {
      try {
        const query = subscribeRaceUpdates(date)
        const result = await apolloClient.subscribe({
          query: gql`${query}`
        })
        result.subscribe({
          next (data) {
            const raceUpdate = mapRace(data.data.raceUpdated)
            context.commit('updateRace', { raceUpdate: raceUpdate })
          },
          error (error) {
            return error
          }
        })
      } catch (error) {
        //
      }
    },
    async saveChangeJockey (context, { runner, jockeyName }) {
      
      try {
        await axios.post('api.public.Public/ChangeJockey', {
          meetingID: context.state.selectedRace.externalMeetingID,
          raceNumber: context.state.selectedRace.raceNumber,
          country: context.state.selectedRace.country,
          date: format(context.state.selectedDate, 'dd/MM/yyyy'),
          venue: context.state.selectedRace.venue,
          meetingType: context.state.selectedRace.meetingType,
          runnerNumber: runner,
          jockeyName: jockeyName
        }, {
          
        })
      } catch (error) {
        //
      }
    },
    async closeRace (context) {
      
      const race = context.state.races[context.state.selectedRace.id]
      try {
        await axios.post('api.public.Public/CloseRace', {
          meetingID: race.meeting.externalIDs[0].id,
          raceNumber: race.number,
          country: race.meeting.track.country,
          date: format(context.state.selectedDate, 'dd/MM/yyyy'),
          venue: race.meeting.track.name,
          meetingType: race.meeting.type
        }, {
          
        })
      } catch (error) {
        //
      }
    },
    async resendPrices (context, { bookie }) {
      
      if (bookie === 0) {
        bookie = ''
      }
      try {
        await axios.post('api.public.Public/ResendPrices', {
          meetingID: context.state.selectedRace.externalMeetingID,
          country: context.state.selectedRace.country,
          date: format(context.state.selectedDate, 'dd/MM/yyyy'),
          meetingType: context.state.selectedRace.meetingType,
          venue: context.state.selectedRace.venue,
          raceNumber: context.state.selectedRace.raceNumber,
          source: bookie
        }, {
          
        })
      } catch (error) {
        //
      }
    },
    async scratchRunner (context, { runnerNumber, action }) {
      
      try {
        await axios.post('api.public.Public/ScratchRunner', {
          meetingID: context.state.selectedRace.externalMeetingID,
          raceNumber: context.state.selectedRace.raceNumber,
          competitorNumber: runnerNumber,
          country: context.state.selectedRace.country,
          date: format(context.state.selectedDate, 'dd/MM/yyyy'),
          venue: context.state.selectedRace.venue,
          meetingType: context.state.selectedRace.meetingType,
          action: action
        }, {
          
        })
      } catch (error) {
        //
      }
    },
    /* selectRace (context, { name, raceId, externalMeetingID, raceNumber, country, venue, meetingType, meetingID, startTime, raceStatus }) {
      context.commit('selectRace', { name, raceId, externalMeetingID, raceNumber, country, venue, meetingType, meetingID, startTime, raceStatus })
    }, */
    async selectRace (context, { id, idChanged }) {
      if (!id) return
      // if (id === context.state.selectedRace.id) return
      if (idChanged) {
        await context.dispatch('fetchRace', { id })
      } else {
        if (context.state.selectedRace.id !== null) {
          await context.dispatch('fetchRace', { id: context.state.selectedRace.id })
        } else {
          await context.dispatch('fetchRace', { id })
        }
      }
      await context.dispatch('fetchMeetingJockeys')
    },
    async fetchRace (context, { id }) {
      try {
        const raceID = JSON.stringify(id)
        const query = queryRace(raceID)
        const result = await apolloClient.query({
          query: gql`${query}`
        })
        const race = result.data.race
        context.commit('selectRace', { id })

        const raceSelected = context.state.races[context.state.selectedRace.id] || context.state.meetingSummaryRaces[context.state.selectedRace.id]

        if (raceSelected.meeting.type !== 'GREYHOUND') {
          const GBSMeetingID = raceSelected.meeting.externalIDs[0].id
          const raceNumber = raceSelected.number

          const res = await axios.post('api.public.Public/GetRaceSilks', {
            MeetingID: GBSMeetingID,
            RaceNumber: raceNumber
          }, {
            
          })

          if (res.data.Runners && res.data.Runners.length > 0) {
            race.competitors.forEach(competitor => {
              res.data.Runners.forEach(runner => {
                if (competitor.tabNo === runner.TabNo) {
                  competitor.silkSVG = runner.SVG
                  competitor.errors = typeof runner.Errors === 'undefined' ? {} : runner.Errors
                  competitor.description = typeof runner.Colours === 'undefined' ? '' : runner.Colours.toLowerCase()
                  competitor.newDescription = typeof runner.NewColours === 'undefined' ? '' : runner.NewColours.toLowerCase()
                }
              })
            })
          } else {
            race.competitors.forEach(competitor => {
              competitor.silkSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 50">' +
              '<defs v-html="defsForPreview"></defs>' +
              '<g>' +
                '<polygon fill="#010202" points="8.562 50 24.678 50 24.678 46.588 8.562 46.588"></polygon>' +
                '<path class="default sleeves" style="" d="M27.8087,50 L24.2977,50 C24.2977,50 23.8087,42.914 24.2977,41.564 C24.7867,40.216 24.9027,25.472 24.7157,25.216 C24.5307,24.96 25.5687,25.239 25.9447,28.426 C26.3207,31.611 26.8317,33.82 27.1347,34.564 C27.4367,35.309 28.0877,42.877 27.8087,50"></path>' +
                '<path class="default torso" style="" d="M24.7979,24.751 C23.5069,22.169 19.2689,20.705 19.2689,20.705 L18.0299,21.123 L17.5069,21.123 C13.9289,19.263 9.0889,18.169 9.0889,18.169 C8.4839,18.169 0.4839,19.239 0.4839,27.519 C0.4839,35.798 3.0419,47.564 3.5999,47.844 C4.1579,48.123 14.0189,48.03 17.6929,48.03 C17.6929,48.03 25.4949,48.437 25.7039,46.658 C25.7039,44.32 26.0879,27.332 24.7979,24.751"></path>' +
                '<g transform="translate(0, 22)">' +
                  '<path class="default sleeves" style="" d="M3.5303,28 C3.5303,28 2.9023,27.007 2.5763,26.704 C2.2513,26.402 1.7393,24.658 1.7623,24.123 C1.7853,23.588 1.2973,21.309 0.9023,20.658 C0.5073,20.007 -0.3537,16.076 0.1573,11.635 C-0.2377,7.867 -0.2377,1.077 5.5763,0.681 C11.3903,0.286 11.4133,7.239 10.7853,10.426 C10.1573,13.611 9.9713,14.681 9.2973,14.867 C8.6233,15.054 8.9023,16.402 9.0883,16.588 C9.2743,16.774 9.6463,17.774 9.1813,18.332 C8.7163,18.891 8.0413,19.379 8.5303,20.007 C9.0183,20.635 10.2743,25.053 9.9253,25.867 C9.5763,26.681 10.2273,28 10.2273,28 L3.5303,28 Z"></path>' +
                '</g>' +
                '<g transform="translate(9, 0)">' +
                  '<path class="default cap" style="" d="M8.0626,4.7856 C10.9276,4.7856 13.4606,5.7056 15.0446,7.1196 C14.6946,3.1266 11.5136,-0.0004 7.6376,-0.0004 C3.5266,-0.0004 0.1936,3.5156 0.1936,7.8516 C0.1936,7.9306 0.2036,8.0076 0.2056,8.0856 C1.5976,6.1376 4.5876,4.7856 8.0626,4.7856"></path>' +
                '</g>' +
                '<path d="M24.0801,7.8521 C24.0801,7.6051 24.0661,7.3611 24.0451,7.1201 C22.4611,5.7061 19.9281,4.7861 17.0621,4.7861 C13.5871,4.7861 10.5981,6.1371 9.2051,8.0851 C9.2181,8.5591 9.2651,9.0241 9.3541,9.4731 C9.6821,9.0591 10.0921,8.6801 10.5561,8.3321 C10.6871,8.2941 11.6951,8.0241 11.7271,8.6111 C11.7631,9.2391 11.2971,10.3551 11.1281,10.6231 C10.9601,10.8911 10.5401,11.9601 10.5291,12.2271 C10.5181,12.4951 9.9371,13.2741 9.8321,13.4141 C9.7271,13.5531 10.9251,14.9141 11.2391,14.8551 C11.5531,14.7971 11.3911,14.5301 11.4491,13.7741 C11.5071,13.0191 11.9601,10.7051 12.4721,10.1931 C12.9791,9.6851 12.8811,7.3551 12.7711,7.1401 C14.0381,6.6611 15.4981,6.3791 17.0621,6.3791 C17.9761,6.3791 18.8511,6.4811 19.6781,6.6551 C19.9151,6.7531 21.0861,7.2601 21.2741,7.7511 C21.4831,8.2971 21.5181,8.9021 21.5071,9.0301 C21.4951,9.1581 21.3791,14.4831 21.2861,14.5651 C21.1921,14.6461 19.8671,15.7511 19.9721,16.1231 C20.0761,16.4951 20.5641,17.0411 20.8551,16.7971 C21.1461,16.5531 22.1921,15.8321 21.9721,15.1691 C21.7511,14.5071 21.7161,10.6231 22.1351,10.1931 C22.5481,9.7681 23.7101,8.6571 23.7421,8.4721 C23.8391,8.5501 23.9441,8.6231 24.0351,8.7041 C24.0631,8.4241 24.0801,8.1401 24.0801,7.8521" fill="#010202"></path>' +
                '<polygon class="default collar" style="" points="18.0303 18.9253 18.0303 21.1233 19.2683 20.7043 19.2683 17.6873"></polygon>' +
                '<path class="default collar" style="" d="M17.5069,18.5879 C17.5069,18.5879 12.9029,15.7049 12.4369,15.7049 C11.9719,15.7049 10.9489,16.0299 10.9489,17.1929 C10.9489,18.3559 9.6929,18.1699 9.0889,18.1699 C9.0889,18.1699 13.9289,19.2629 17.5069,21.1229 L17.5069,18.5879 Z"></path>' +
              '</g>' +
            '</svg>'
              competitor.errors = {}
              competitor.description = ''
              competitor.newDescription = ''
            })
          }
        }

        context.commit('updateDetailedRace', { race })
        const d = context.state.selectedDate
        const date = JSON.stringify(d)
        context.dispatch('subscribeDetailedRace', { id, date })
      } catch (error) {
        //
      }
    },
    async silksErrorsByRace (context, { GBSMeetingID, raceNumber }) {

      const res = await axios.post('api.public.Public/GetRaceSilks', {
        MeetingID: GBSMeetingID,
        RaceNumber: raceNumber
      }, {
        
      })

      if (typeof res.data.Race.Errors !== 'undefined' && Object.keys(res.data.Race.Errors).length > 0) {
        return 1
      }
      return 0
    },

    async subscribeDetailedRace (context, { id, date }) {
      try {
        const raceId = JSON.stringify(id)
        const query = subscribeDetailedRace(raceId, date)
        const result = await apolloClient.subscribe({
          query: gql`${query}`
        })
        const subscription = result.subscribe({
          next (data) {
            const raceUpdate = data.data.raceUpdated
            const key = `${raceUpdate.id}`

            const detailedRace = context.state.detailedRaces[key]
            if (detailedRace) {
              if (raceUpdate.competitors && raceUpdate.competitors.length > 0) {
                const competitors = detailedRace?.competitors ? [...detailedRace.competitors] : []
                // raceUpdate.competitors.forEach(competitor => {
                //   const index = competitors.findIndex(c => c.tabNo === competitor.tabNo)
                //   if (index) {
                //     if (competitors[index]?.scratched !== competitor.scratched) {
                //       context.commit('setRacedayUpdates', { meetingDate: raceUpdate.meeting.date, raceId: raceUpdate.id, raceNumber: raceUpdate.number, dateUpdate: raceUpdate.updated, raceName: raceUpdate.meeting.track.name, updateType: 'Scratching', oldValue: false, newValue: competitor.tabNo + ' ' + competitor.name })
                //     }

                //     if (competitors[index]?.jockey !== competitor.jockey && competitor.jockey !== '') {
                //       context.commit('setRacedayUpdates', { meetingDate: raceUpdate.meeting.date, raceId: raceUpdate.id, raceNumber: raceUpdate.number, dateUpdate: raceUpdate.updated, raceName: raceUpdate.meeting.track.name, updateType: 'Rider', oldValue: competitors[index]?.tabNo + ' ' + competitors[index]?.jockey, newValue: competitor.jockey })
                //     }
                //     competitors[index] = { ...competitor, runner: { id: competitors[index]?.runner?.id } }
                //   }
                // })
                const newDetailedRace = { ...raceUpdate, competitors }
                context.commit('updateRaceDetail', { detailedRace: newDetailedRace })
              } else {
                const newDetailedRace = { ...raceUpdate, competitors: [...detailedRace.competitors] }
                context.commit('updateRaceDetail', { detailedRace: newDetailedRace })
              }
            }
          }
        })
        // context.commit('socketOpen')
        context.commit('updateDetailedRaceSubscription', { subscription })
      } catch (error) {
        //
      }
    },
    async setDate (context, d) {
      context.commit('setDate', d)
      await context.dispatch('fetchRaces')
    },
    async setDateMeetingSummary (context, d) {
      context.commit('setDateMeetingSummary', d)
      await context.dispatch('fetchMeetingSummaryRaces')
    },
    async setRaceResults (context, { firsts, seconds, third, fourths, dividends }) {
      

      var interim = false
      if (context.state.selectedRace.raceStatus === 'INTERIM') {
        interim = true
      }

      var finalPositionsMessage = []

      firsts.forEach(first => {
        finalPositionsMessage.push({
          position: 1,
          runner: parseInt(first)
        })
      })

      seconds.forEach(second => {
        finalPositionsMessage.push({
          position: 2,
          runner: parseInt(second)
        })
      })

      third.forEach(three => {
        finalPositionsMessage.push({
          position: 3,
          runner: parseInt(three)
        })
      })

      fourths.forEach(fourth => {
        finalPositionsMessage.push({
          position: 4,
          runner: parseInt(fourth)
        })
      })

      var dividendsMessage = []

      dividends.forEach(dividend => {
        if (dividend.dividend !== 0) {
          dividendsMessage.push({
            dividendType: dividend.betType,
            combination: ((dividend.combination).split(',')).map(comb => +comb),
            price: parseFloat(dividend.dividend)
          })
        }
      })

      try {
        await axios.post('api.public.Public/SetRaceResults', {
          meetingID: context.state.selectedRace.externalMeetingID,
          country: context.state.selectedRace.country,
          date: format(context.state.selectedDate, 'dd/MM/yyyy'),
          meetingType: context.state.selectedRace.meetingType,
          venue: context.state.selectedRace.venue,
          raceNumber: context.state.selectedRace.raceNumber,
          isInterim: interim,
          finalPositions: finalPositionsMessage,
          dividends: dividendsMessage
        }, {
          
        })
      } catch (error) {
        //
      }
    },
    async setTimeRace (context, { optionSelected, newTime, minutes }) {
      
      const race = context.state.races[context.state.selectedRace.id]
      var arrayRaces = []

      if (optionSelected === 'startTime') {
        const hoursMinutes = newTime.split(':')
        var setTime = new Date(race.startTime)
        setTime.setHours(Number(hoursMinutes[0]), Number(hoursMinutes[1]))
        const timeToTimestamp = getUnixTime(setTime)

        arrayRaces[0] = {
          number: race.number,
          startTime: timeToTimestamp
        }
      } else {
        const races = context.state.meetings[race.meeting.id].Races

        races.forEach(r => {
          const setTimeWithMinutes = new Date(r.startTime)
          setTimeWithMinutes.setMinutes(setTimeWithMinutes.getMinutes() + Number(minutes))
          const timeToTimestamp = getUnixTime(setTimeWithMinutes)

          arrayRaces.push({
            number: r.Number,
            startTime: timeToTimestamp
          })
        })
      }

      try {
        await axios.post('api.public.Public/SetRaceTime', {
          meetingID: race.meeting.externalIDs[0].id,
          races: arrayRaces,
          country: race.meeting.track.country,
          date: format(context.state.selectedDate, 'dd/MM/yyyy'),
          venue: race.meeting.track.name,
          meetingType: race.meeting.type
        }, {
          
        })
      } catch (error) {
        //
      }
    },
    async fetchRunnerSVG (context, { GBSMeetingID, raceNumber, runnerNumber }) {
      try {
        const res = await axios.post('api.public.Public/GetRunnerSVG', {
          meetingID: GBSMeetingID,
          raceNumber: raceNumber,
          tabNo: runnerNumber
        }, {
          
        })
        return res.data.SVG
      } catch (error) {
        //
      }
    },
    updateRaceNavFilter (context, { filter, value }) {
      try {
        switch (filter) {
          case 'countries':
            context.commit('updateCountries', value)
            setUserFilter('filteredCountries', value)
            break
          case 'codes':
            context.commit('updateCodes', value)
            setUserFilter('filteredCodes', value)
            break
        }
      } catch (error) {
        //
      }
    },
    resetRaceFilters (context) {
      try {
        context.commit('updateCountries', defaultCountries)
        setUserFilter('filteredCountries', defaultCountries)
        context.commit('updateCodes', defaultCodes)
        setUserFilter('filteredCodes', defaultCodes)
      } catch (error) {
        //
      }
    },
    async fetchUserFilters (context) {
      try {
        const config = context.getters['account/authConfig']
        const keyList = [
          'filteredCountries',
          'filteredCodes'
        ]
        const results = await batchFetch(keyList, config)
        if (!results) {
          return
        }
        // const savedCountries = await fetchUserFilter('filteredCountries', config)
        if (results.filteredCountries) {
          context.commit('updateCountries', JSON.parse(results.filteredCountries))
        }
        // const savedCodes = await fetchUserFilter('filteredCodes', config)
        if (results.filteredCodes) {
          context.commit('updateCodes', JSON.parse(results.filteredCodes))
        }
      } catch (error) {
        //
      }
      // const races = results[`myRaces:${date}`]
      // context.commit('addToMyRaces', { races: [] })
      // if (races) {
      //   context.commit('addToMyRaces', { races })
      // }
    },
    selectNavRace (context, { id }) {
      context.commit('selectNavRace', { id })
    },
    selectRaceNav (context, v) {
      context.commit('setSelectRaceNav', v)
    },
    async regenerateRaceSilks (context) {
      
      const race = context.state.races[context.state.selectedRace.id]
      const GBSMeetingID = race.meeting.externalIDs[0].id
      const raceNumber = race.number
      const competitors = context.state.detailedRaces[context.state.selectedRace.id].competitors
      await axios.post('api.public.Public/RegenerateRaceSilks', {
        MeetingID: GBSMeetingID,
        RaceNumber: raceNumber
      }, {
        
      })
      competitors.forEach(async competitor => {
        await axios.post('api.public.Public/RegenerateRunnerSilks', {
          MeetingID: GBSMeetingID,
          RaceNumber: raceNumber,
          TabNo: competitor.tabNo
        }, {
          
        })
      })

      await context.dispatch('fetchRace', { id: race.id })
    },
    async saveDescription (context, { newDescription, runnerNumber }) {
      const race = context.state.races[context.state.selectedRace.id]
      const GBSMeetingID = race.meeting.externalIDs[0].id
      const raceNumber = race.number
      try {
        await axios.post('api.public.Public/SetRunnerDescription', {
          MeetingID: GBSMeetingID,
          RaceNumber: raceNumber,
          TabNo: runnerNumber,
          NewColours: newDescription
        }, {
          
        })
        context.dispatch('regenerateRaceSilks')
      } catch (error) {
        //
      }
    },
    async getUsers (context) {
      try {
        const res = await axios.post('api.public.Public/GetUsers', {}, {
          
        })
        context.commit('saveUsers', { users: res.data.userId })
      } catch (error) {
        //
      }
    },
    // async createUser (context, { userID, priceSources, selectedCountries, selectedMeetingTypes, fieldsDisallowed, generatedPriceSource, priceManagerClientID, raceCardSource }) {
    async createUser (context, { userID, policies, serviceNowLink }) {
      try {
        await axios.post('api.public.Public/CreateUser', {
          userId: userID,
          // filter: {
          //   countries: selectedCountries,
          //   codes: selectedMeetingTypes,
          //   fieldsDisallowed: fieldsDisallowed,
          //   priceSources: priceSources,
          //   generatedPriceSource: generatedPriceSource,
          //   pricemanagerClientId: priceManagerClientID,
          //   racecardSource: raceCardSource
          // },
          filter: {},
          issuer: '',
          policies: policies.split('\n'),
          serviceNowLink: serviceNowLink
        }, {
          
        })
      } catch (error) {
        //
      }
    },
    async createApiKey (context, { userID }) {
      try {
        const res = await axios.post('api.public.Public/CreateApiKey', {
          userId: userID
        }, {
          
        })
        return res.data
      } catch (error) {
        //
      }
    },
    async getUserKey (context, { userID }) {
      try {
        const apiKeys = await axios.post('api.public.Public/GetUserKey', {
          userId: userID
        }, {
          
        })
        return apiKeys.data.apiKey
      } catch (error) {
        //
      }
    },
    async deleteApiKey (context, { clientID }) {
      try {
        await axios.post('api.public.Public/DeleteApiKey', {
          clientId: clientID
        }, {
          
        })
      } catch (error) {
        //
      }
    },
    async getUser (context, { userID }) {
      try {
        const res = await axios.post('api.public.Public/GetUser', {
          userId: userID
        }, {
          
        })
        context.commit('saveUser', { user: res.data })
        return res.data
      } catch (error) {
        //
      }
    },
    // async updateUser (context, { userID, priceSources, selectedCountries, selectedMeetingTypes, fieldsDisallowed, generatedPriceSource, priceManagerClientID, raceCardSource }) {
    async updateUser (context, { userID, policies, serviceNowLink }) {
      try {
        await axios.post('api.public.Public/UpdateUser', {
          userId: userID,
          // filter: {
          //   countries: selectedCountries,
          //   codes: selectedMeetingTypes,
          //   fieldsDisallowed: fieldsDisallowed,
          //   priceSources: priceSources,
          //   generatedPriceSource: generatedPriceSource,
          //   pricemanagerClientId: priceManagerClientID,
          //   racecardSource: raceCardSource
          // },
          filter: {},
          issuer: '',
          policies: policies.split('\n'),
          serviceNowLink: serviceNowLink

        }, {
          
        })
      } catch (error) {
        //
      }
    },
    async deleteUser (context, { userID }) {
      try {
        await axios.post('api.public.Public/DeleteUser', {
          userId: userID
        }, {
          
        })
        context.dispatch('getUsers')
      } catch (error) {
        //
      }
    },
    async fetchPriceSources (context) {
      try {
        const res = await axios.post('api.public.Public/GetPriceSources',
          {},
          {
            
          })
        context.commit('clearPriceSources')
        context.commit('updatePriceSources', { priceSources: res.data.priceSources })
      } catch (error) {
        //
      }
    },
    
    async sendBroadcastMessage (context, { message }) {
      try {
        await axios.post('api.public.Public/SendBroadcastMessage',
          {
            message: message
          },
          {
            
          })
      } catch (error) {
        //
      }
    },
    async saveUserPermissions (context, { username, permissions }) {
      try {
        await axios.post('api.public.Public/SaveUserPermissions', {
          username: username,
          roles: JSON.stringify(permissions)
        }, {
          
        })
        context.dispatch('fetchUserWithRoles')
      } catch (error) {
        //
      }
    },
    async saveRole (context, { roleName, permissions }) {
      try {
        await axios.post('api.public.Public/InsertRole', {
          roleName: roleName,
          permissions: permissions
        }, {
          
        })
        context.dispatch('fetchRoles')
      } catch (error) {
        //
      }
    },
    async fetchRoles (context) {
      try {
        const res = await axios.post('api.public.Public/GetRoles', {}, {
          
        })
        context.commit('saveRoles', { roles: res.data.roles })
      } catch (error) {
        //
      }
    },
    async fetchUserWithRoles (context) {
      try {
        const res = await axios.post('api.public.Public/GetUsersWithRoles', {}, {
          
        })
        const users = res.data.usersWithRoles
        users.forEach((user) => {
          const roles = JSON.parse(user.roles)
          const rolesIdToName = []
          roles.forEach((role) => {
            if (role === '*') {
              rolesIdToName.push('Admin')
            } else {
              const findRole = context.state.roles.find(r => r.id === role)
              rolesIdToName.push(findRole.roleName)
            }
          })
          user.rolesNames = rolesIdToName
        })
        context.commit('saveUsersWithRoles', { users: users })
      } catch (error) {
        //
      }
    },
    async fetchUserByUsername (context, { username }) {
      try {
        context.dispatch('fetchRoles')
        const res = await axios.post('api.public.Public/GetUserByUsername', {
          username: username
        }, {
          
        })
        const user = res.data.user
        user.roles = JSON.parse(user.roles)
        context.commit('saveUserLoggedIn', { user: user })
      } catch (error) {
        //
      }
    },
    async deleteUserWithRoles (context, { username }) {

      try {
        await axios.post('api.public.Public/DeleteUserWithRoles', {
          username: username
        }, {
          
        })
      } catch (error) {
        //
      }
    },
    async deleteRole (context, { roleId }) {

      try {
        await axios.post('api.public.Public/DeleteRole', {
          roleId: roleId
        }, {
          
        })
      } catch (error) {
        //
      }
    },
    updateRacesSilksDialog (context, { value }) {
      context.commit('setRacesSilksDialog', { value: value })
    }
  },
  getters: {
    getUserPermissions (state){
      let permissions = []  
      state.userLoggedIn.roles.forEach(roleId =>{
        let role = state.roles.find(r=>r.id == roleId)
        if(role) { permissions = permissions.concat(role.permissions) }
        })
      return permissions
    },
    getRaces (state, getters) {
      if (state.filterRacesByFinalStatus) {
        return filterRacesByStatuses(state.races, getters.getStatusesFilter)
      } else {
        return filterRacesByCondition(filterRacesByDistance(filterRacesByStarters(filterRacesByStatuses(filterRacesByMeetingType(filterRacesByCodes(filterRacesByCountry(state.races, getters.getCountriesFilter), getters.getIsCodesSelectedFilter), getters.getMeetingTypesSelectedFilter), getters.getStatusesFilter), getters.getStartersFilter), getters.getDistanceFilter), getters.getConditionsFilter)
      }
    },
    getMeetingSummaryRaces (state, getters) {
      return filterRacesByCodes(filterRacesByCountry(state.meetingSummaryRaces, getters.getCountriesFilter), getters.getIsCodesSelectedFilter)
    },
    getSelectedRaceCompetitors (state) {
      if (state.selectedRace.raceId === null) {
        return null
      } else {
        const race = state.races[state.selectedRace.raceId]
        if (race) {
          return race.competitors
        }
      }
    },
    getSelectedMeeting (state) {
      if (state.selectedRace.id === null) {
        return null
      }
      const race = state.races[state.selectedRace.id] || state.meetingSummaryRaces[state.selectedRace.id]
      if (race) {
        const meeting = state.meetings[race.meeting.id] || state.meetingSummaryMeetings[race.meeting.externalIDs[0].id]
        return meeting
      }
      return null
    },
    getSelectedMeetingsRaces (state, getters) {
      let meetingsRaces = Object.values(state.races).filter(race => race?.meeting?.id === getters.getSelectedMeeting?.id)

      if (meetingsRaces.length === 0) {
        meetingsRaces = Object.values(state.meetingSummaryRaces).filter(race => race?.meeting?.id === getters.getSelectedMeeting?.id)
      }
      return meetingsRaces
    },
    getSelectedRace (state, getters) {
      return function () {
        if (state.selectedRace.id === null) {
          return null
        }
        const race = state.detailedRaces[state.selectedRace.id]
        return {
          ...race,
          competitors: getters.getRaceCompetitors
        }
      }
    },
    getRaceCompetitors (state) {
      let sortedCompetitors = []
      const competitors = state.detailedRaces[state.selectedRace?.id]?.competitors || []
      sortedCompetitors = competitors
      return sortedCompetitors
    },
    getNextToGo (state, getters) {
      const r = Object.values([...getters.getRaces])
      let res = null
      r.sort((a, b) => isBefore(a.isoStartTime, b.isoStartTime) ? -1 : 1)
      r.some((x) => {
        if (x.status === 'OPEN') {
          res = x
          return true
        }
      })
      return res
    },
    getRacesGroupedByMeeting (state, getters) {
      return filterMeetingsByCodes(filterMeetingsByCountry(state.racesGroupedByMeeting, getters.getCountriesFilter), getters.getIsCodesSelectedFilter)
    },
    getSilksErrorsLoading (state) {
      return state.silksErrorsLoading
    },
    getUsers (state) {
      return state.users
    },
    getUser (state) {
      return state.user
    },
    getSportTypes (state) {
      return state.sportTypes
    },
    getSportMarkets (state) {
      return state.sportMarkets
    },
    getSportCategories (state) {
      return state.sportCategories
    },
    getSportResultSelections (state) {
      return state.sportResultSelections
    },
    getSportEvent (state) {
      return state.sportEvent
    },
    getSources (state) {
      return state.priceSources
    },
    getShapes (state) {
      return state.shapes
    },
    getRoles (state) {
      return state.roles
    },
    getUsersWithRoles (state) {
      return state.usersWithRoles
    },
    getUserLoggedIn (state) {
      return state.userLoggedIn
    },
    getRacesSilksDialog (state) {
      return state.racesSilksDialog
    },
    getLoggedIn(state){
      return state.loggedIn
    }
  }
}

export default store
